import React from 'react';
import PropTypes from 'prop-types';
import { join } from 'lodash';
import { formatDate } from 'utils/Formatters';
import { isAdminDashboard } from 'utils/authScopes';

export default class AccountsRow extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    data:  PropTypes.object.isRequired,
    onAccount: PropTypes.func.isRequired,
  }

  onAccount = (e) => {
    e.stopPropagation();
    this.props.onAccount(this.props.data.id);
  }

  render() {
    const { auth, data } = this.props;
    return (
      <tr className='u-pointer' onClick={this.onAccount}>
        <td>{data.id}</td>
        <td>{data.firstName}</td>
        <td>{data.lastName}</td>
        <td>{data.email}</td>
        <td>{formatDate(data.createdAt)}</td>
        { isAdminDashboard(auth) && <td>{data.partner}</td> }
        <td>{join(data.children, '\n')}</td>
        <td>{formatDate(data.lastAppTouch)}</td>
        <td>{formatDate(data.lastActivity)}</td>
        <td>{data.archived ? 'Archived' : 'Active'}</td>
        <td>{data.totalPlays}</td>
        <td>{data.totalPhotos}</td>
        {/* <td>
          <i className='fa fa-trash-o' title='Delete' onClick={this.onDelete}></i>
          <i className='fa fa-ban u-padding-left--small' title='Block' onClick={this.onBlock}></i>
        </td> */}
      </tr>
    );
  }
}
